import { Accordion } from "@/components/ui/accordion";
import { FAQItem } from "./faq/FAQItem";
import { proFAQs, userFAQs } from "./faq/FAQData";

interface FAQProps {
  isPro: boolean;
}

export const FAQ = ({ isPro }: FAQProps) => {
  const faqs = isPro ? proFAQs : userFAQs;

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-mono font-bold text-primary mb-12 text-center">
          {isPro ? "Questions Fréquentes" : "On répond à vos questions"}
        </h2>

        <Accordion type="single" collapsible className="space-y-6">
          {faqs.map((faq) => (
            <FAQItem key={faq.value} {...faq} />
          ))}
        </Accordion>
      </div>
    </section>
  );
};